import React from 'react';
import ListView from '../../Common/Views/ListView';

import stringUtils from '../../utils/stringUtils';

const InventoryTransactionsList = ({
    filters = {},
    // onSelect = () => { },

    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.

    searchBox = true, // whether to show the search box
    searchAttributes = [
        { name: "Name", value: "name" },
        { name: "Code", value: "code" },
        { name: "Search Id", value: "searchId" },
    ],

    noResultsMessage = "No inventory stock found"

}) => {

    // Columns configuration for rendering inventory transactions list
    const columnsConfig = {
        locationName: {
            key: 'locationName',
            label: 'Location No',
            render: row => row.location.name
        },
        itemName: {
            key: 'itemName',
            label: 'Item name',
            render: row => row.item.name
        },
        transactionType: {
            key: 'transactionType',
            label: 'Transaction type',
            render: row => row.transactionType
        },
        quantity: {
            key: 'quantity',
            label: 'Quantity',
            render: row => `${row.quantity} (${row.item.uom})`
        },
        notes: {
            key: 'notes',
            label: 'Notes',
            render: row => row.notes
        },
        date: {
            key: 'date',
            label: 'Date',
            render: row => stringUtils.isoToLocalDateTime(row.created_at)
        }
    };

    return <ListView
        title="Inventory transactions"
        apiPath="/tenants/inventory/transactions"
        filters={filters}

        addButton={false}

        rowClickPath={(item) => `/inventory/transactions/${item.id}`}
        onSelect={() => { }}

        columnsConfig={columnsConfig}
        columns={columns}

        searchBox={searchBox}
        searchAttributes={searchAttributes}

        noResultsMessage={noResultsMessage}
    />
};

export default InventoryTransactionsList;